/**
 * Limits the precision of a number to a specified number of decimal places.
 *
 * The default precision works well for handling floating point inaccuracies
 * such as the following, which can occur when converting between percentages
 * and their decimal representations:
 *
 * 28 / 100 * 100 === 28.000000000000004
 *
 * For values that are the result of complex calculations, and likely inaccurate
 * anyway, we should limit the precision further, for example to 3.
 *
 * @param number - The number to limit the precision of.
 * @param precision - The number of significant digits to limit the precision to.
 * @returns The number with the limited precision.
 */
export function limitNumberPrecision(number: number, precision: number = 12) {
  return stripTrailingZerosAfterDecimalPoint(number.toPrecision(precision))
}

function stripTrailingZerosAfterDecimalPoint(number: string) {
  return Number(number).toString()
}
